<div class="upload-progress" *ngIf="uploadService.showSharedProgressBar()">
    <div class="upload-progress__label" id="uploadProgressLabel">File upload in progress</div>
    <div
        class="upload-progress__track"
        role="progressbar"
        aria-labelledby="uploadProgressLabel"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="uploadService.progress()"
    >
        <div class="upload-progress__bar" [style.width.%]="progressWidth()"></div>
    </div>
</div>
